module.exports = global;
